/**
 * Created by sungho.hong on 2020-03-10.
 */

function ONCompanyBox($container) {
    this.$container = $container;
    this.$btnSelect;
    this.$listContainer;
    this.$searchContainer;
    this.$listItems;

    this.init();
}

ONCompanyBox.prototype.init = function() {
    var _ = this;

    _.$btnSelect = _.$container.find('.btn-companies');
    _.$listContainer = _.$container.find('.console-companies');
    _.$searchContainer = _.$container.find('.search-word');
    _.$textField = _.$searchContainer.find('input[type=text]');
    _.$listItems = _.$listContainer.find('button');

    _.initEvent();
}

ONCompanyBox.prototype.initEvent = function() {
    var _ = this;

    //console.log(_.$listItems);

    _.$btnSelect.off('click').on('click', function(e) {
        //console.log(e);
        $(this).toggleClass("selected");

        _.$listContainer.one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend", function() {
            _.$textField.focus();
        });
    });

    _.$btnSelect.on('keydown', function(e) {
        switch(e.keyCode) {
            case 40: {
                _.$listContainer.find('button:visible').eq(0).focus();
                break;
            }
        }
    })

    _.$listItems.off('click').on('click', function(e) {
        //console.log(e);
        _.select($(this));
    });

    _.$listItems.on('keydown', function(e) {
        //console.log(e.keyCode);
        switch(e.keyCode) {
            case 38: {
                var $items = _.$listContainer.find('button:visible');
                var index = $items.index(this);
                if( index == 0 ) {
                    _.$textField.focus();
                } else {
                    $items.eq(index-1).focus();
                }
                break;
            }

            case 40: {
                var $items = _.$listContainer.find('button:visible');
                var index = $items.index(this);
                $items.eq(index+1).focus();
                break;
            }
        }
    });

    _.$textField.on('keyup', function(e) {
        var keyword = e.target.value.toString();
        var $btns = _.$listContainer.find('.list-companies button');
        if( keyword.length <= 0 ) {
            $btns.closest('li').removeClass('not-match');
        }
        $.each($btns, function(index, element) {
            var orgText = $(element).text();
            orgText = orgText.replace('<mark>', '').replace('</mark>', '');
            var startIdx = orgText.toUpperCase().indexOf(keyword.toUpperCase());
            var length = keyword.length;
            var markWord = orgText.slice(startIdx, length);
            if(orgText.toUpperCase().indexOf(keyword.toUpperCase()) !== -1){
                newText = orgText.replace(markWord, '<mark>' + markWord +'</mark>');
                $(element).html(newText);
                $(element).closest('li').removeClass('not-match');
            } else {
                $(element).closest('li').addClass('not-match');
            }
        });
        switch(e.keyCode) {
            case 40: {
                _.$listContainer.find('button:visible').eq(0).focus();
                break;
            }
        };
    });
}

ONCompanyBox.prototype.hide = function() {
    var _ = this;

    _.$btnSelect.removeClass("selected")
}

ONCompanyBox.prototype.select = function($item) {
    var _ = this;

    _.$listItems.closest('li').removeClass('selected');
    $item.closest('li').addClass('selected');

    //_.$btnSelect.html($item.html());
    _.$btnSelect.html($item.html().replace('<mark>', '').replace('</mark>', ''));
    _.hide();
}

ONCompanyBox.prototype.resetSearchWord = function() {
    var _ = this;

    _.$textField.val('').trigger('keyup');
}

exports.ConsoleGNB= (function ($) {
    var $container,
        $btnNotification,
        $btnUser,
        $listNotice,
        $layerMenusContainer,
        selectCompany,
        containerWidth,
        indexSubmenu = 0,
        pages = [0],

        init = function() {
            $container = $('.console-gnb');
            $layerMenusContainer = $container.find('.service-container .service-container-inner');
            $btnNotification = $container.find('.btn[data-icon=notice]');
            $btnUser = $container.find('.btn.user');
            $listNotice = $container.find('.list-gnb-notice');

            selectCompany = new ONCompanyBox($('#select-company'));

            initLayout();
            initEvent();
        },
        setCompany = function() {
            selectCompany = new ONCompanyBox($('#select-company'));

            $(document).click(function (event) {
                if( !$(event.target).closest("#select-company").length ) {
                    selectCompany.resetSearchWord();
                    selectCompany.hide();
                }
            });
        };
        reInintLayout = function () {

            $container = $('.console-gnb');

            $('.layout-wrap').css({
                paddingTop: $container.outerHeight() + "px"
            });

            _scrollFixed();
            $(window).scroll(_scrollFixed);

        };

    function initLayout() {
        $('.layout-wrap').css({
            paddingTop: $container.outerHeight() + "px"
        });

    }

    function initEvent() {
        $btnNotification.on('click', function(e) {
            $(this).toggleAttr('data-state', 'open');
        });

        $btnUser.on('click', function(e) {
            $(this).toggleAttr('data-state', 'open');
        });

        $container.find('.ticker-wrapper').easyTicker({
            direction: 'up',
            interval: 5000,
            visible: 1,
            mousePause: 1
        });

        _scrollFixed();
        $(window).scroll(_scrollFixed);

        $(document).click(function (e) {

            if( !$(e.target).closest("#select-company").length ) {
                selectCompany.resetSearchWord();
                selectCompany.hide();
            }

            if( !$(e.target).closest("[data-icon=notice]").length ) {
                $btnNotification.removeAttr('data-state');
            }

            if( !$(e.target).closest(".user").length ) {
                $btnUser.removeAttr('data-state');
            }

        });

    }

    function _scrollFixed() {
        $container.css("left", -$(this).scrollLeft());
    }

    return {
        init: function() {
            init();
        },
        setCompany: function() {
            setCompany();
        },
        reInintLayout : function () {
            reInintLayout();
        }
    };
}(jQuery));


exports.GlobalPrntCompany= (function ($) {
    var $container,
        $btnNotification,
        $btnUser,
        $listNotice,
        $layerMenusContainer,
        selectPrntCompany,
        selectChldCompany,

        init = function() {
            $container = $('.console-gnb');
            $layerMenusContainer = $container.find('.service-container .service-container-inner');
            $btnNotification = $container.find('.btn[data-icon=notice]');
            $btnUser = $container.find('.btn.user');
            $listNotice = $container.find('.list-gnb-notice');

            selectPrntCompany = new ONCompanyBox($('#select-prnt-company'));

            initLayout();
            initEvent();
        },
        setPrntCompany = function() {
            selectPrntCompany = new ONCompanyBox($('#select-prnt-company'));
            $(document).click(function (e) {
                if( !$(e.target).closest("#select-prnt-company").length ) {
                    selectPrntCompany.resetSearchWord();
                    selectPrntCompany.hide();
                }
            });

        },
        reInintLayout = function () {

            $container = $('.console-gnb');

            $('.layout-wrap').css({
                paddingTop: $container.outerHeight() + "px"
            });

            _scrollFixed();
            $(window).scroll(_scrollFixed);

        };

    function initLayout() {

        $('.layout-wrap').css({
            paddingTop: $container.outerHeight() + "px"
        });

    }

    function initEvent() {
        $btnNotification.on('click', function(e) {
            $(this).toggleAttr('data-state', 'open');
        });

        $btnUser.on('click', function(e) {
            $(this).toggleAttr('data-state', 'open');
        });

        $container.find('.ticker-wrapper').easyTicker({
            direction: 'up',
            interval: 5000,
            visible: 1,
            mousePause: 1
        });

        _scrollFixed();
        $(window).scroll(_scrollFixed);

        $(document).click(function (e) {
            selectChldCompany.hide();

            if( !$(e.target).closest("#select-prnt-company").length ) {
                selectPrntCompany.resetSearchWord();
                selectPrntCompany.hide();
            }

            if( !$(e.target).closest("[data-icon=notice]").length ) {
                $btnNotification.removeAttr('data-state');
            }

            if( !$(e.target).closest(".user").length ) {
                $btnUser.removeAttr('data-state');
            }
        });

    }

    function _scrollFixed() {
        $container.css("left", -$(this).scrollLeft());
    }

    function toggleClass(){
        $('#select-prnt-company').find('.btn-companies').toggleClass('selected');
    }

    function closeBox(){
        if($('#select-prnt-company').find('.btn-companies').hasClass('selected')){
            $('#select-prnt-company').find('.btn-companies').toggleClass('selected');
        }
    }

    return {
        init: function() {
            init();
        },
        setPrntCompany: function() {
            setPrntCompany();
        },
        reInintLayout : function () {
            reInintLayout();
        },
        toggleClass : function () {
            toggleClass();
        },
        closeBox : function () {
            closeBox();
        },
    };
}(jQuery));

exports.GlobalChldCompany= (function ($) {
    var $container,
        $btnNotification,
        $btnUser,
        $listNotice,
        $layerMenusContainer,
        selectChldCompany,
        selectPrntCompany,

        init = function() {
            $container = $('.console-gnb');
            $layerMenusContainer = $container.find('.service-container .service-container-inner');
            $btnNotification = $container.find('.btn[data-icon=notice]');
            $btnUser = $container.find('.btn.user');
            $listNotice = $container.find('.list-gnb-notice');

            selectChldCompany = new ONCompanyBox($('#select-chld-company'));

            initLayout();
            initEvent();
        },
        setChldCompany = function() {
            selectChldCompany = new ONCompanyBox($('#select-chld-company'));
            $(document).click(function (e) {
                if( !$(e.target).closest("#select-chld-company").length ) {
                    selectChldCompany.resetSearchWord();
                    selectChldCompany.hide();
                }
            });
        },
        reInintLayout = function () {

            $container = $('.console-gnb');

            $('.layout-wrap').css({
                paddingTop: $container.outerHeight() + "px"
            });

            _scrollFixed();
            $(window).scroll(_scrollFixed);

        };

    function initLayout() {

        $('.layout-wrap').css({
            paddingTop: $container.outerHeight() + "px"
        });

    }

    function initEvent() {
        $btnNotification.on('click', function(e) {
            $(this).toggleAttr('data-state', 'open');
        });

        $btnUser.on('click', function(e) {
            $(this).toggleAttr('data-state', 'open');
        });

        $container.find('.ticker-wrapper').easyTicker({
            direction: 'up',
            interval: 5000,
            visible: 1,
            mousePause: 1
        });

        _scrollFixed();
        $(window).scroll(_scrollFixed);

        $(document).click(function (e) {

            selectPrntCompany.hide();

            if( !$(e.target).closest("#select-chld-company").length ) {
                selectChldCompany.resetSearchWord();
                selectChldCompany.hide();
            }

            if( !$(e.target).closest("[data-icon=notice]").length ) {
                $btnNotification.removeAttr('data-state');
            }

            if( !$(e.target).closest(".user").length ) {
                $btnUser.removeAttr('data-state');
            }
        });

    }

    function _scrollFixed() {
        $container.css("left", -$(this).scrollLeft());
    }

    function toggleClass(){
        $('#select-chld-company').find('.btn-companies').toggleClass('selected');
    }

    function closeBox(){
        if($('#select-chld-company').find('.btn-companies').hasClass('selected')){
            $('#select-chld-company').find('.btn-companies').toggleClass('selected');
        }
    }

    return {
        init: function() {
            init();
        },
        setChldCompany: function() {
            setChldCompany();
        },
        reInintLayout : function () {
            reInintLayout();
        },
        toggleClass : function () {
            toggleClass();
        },
        closeBox : function () {
            closeBox();
        }
    };
}(jQuery));



// WEBPACK FOOTER //
// ./src/components/common/layout/gnb/gnb.js